import BlainBaseService from "./BlainBaseService";
import { ICustomerAddress } from "JS/types/Customer";

export type EditAddressResponse =
    | { success: true; address: ICustomerAddress }
    | { success: false; errors: Record<string, string> }

export type VerifyZipResponse =
    | { success: true; cities: string[], state: string, stateFullName: string }
    | { success: false; message: string }

export interface IAccountAddressService {
	/**
	 * Apply changes to an existing customer address on the backend
	 * @param address Modified address object to post to the backend
	 */
	editAddress(address: ICustomerAddress): Promise<EditAddressResponse>

	/**
	 * Delete an existing customer address on the backend
	 * @param id of the address to be deleted
	 */
	deleteAddress(addressId: number): Promise<{success: boolean}>

	/**
     * Queries for validity, city, and state information for the passed zip code
	 * @param zip Potential zip code from user input
	 */
	verifyZip(zip: string): Promise<VerifyZipResponse>;
}

export default class AccountAddressService extends BlainBaseService implements IAccountAddressService {
	async editAddress(address: ICustomerAddress): Promise<EditAddressResponse> {
		return this._httpSvc.post<EditAddressResponse>(`/account/address/edit`, address);
	}

	async deleteAddress(addressId: number): Promise<{success: boolean}> {
		if (addressId < 1) return null;
		return this._httpSvc.post<{success: boolean}>(`/account/address/delete`, { addressId });
	}

	async verifyZip(zip: string): Promise<VerifyZipResponse> {
		return this._httpSvc.get<VerifyZipResponse>(`/account/address/verify-zip/?zip=${zip}`);
	}
}